import * as React from 'react';

import MaterialCostSource from 'ab-enums/materialCostSource.enum';

import MaterialRateSource from 'af-components/MaterialRateSource';

import styles from './styles.module.scss';

const TableLegend: React.FC = () => {
	return (
		<div className={styles.TableLegend}>
			<div className={styles.rateItem}>
				<MaterialRateSource className={styles.rateSource} rateSource={MaterialCostSource.JOB} /> Rates on job level
			</div>
			<div className={styles.rateItem}>
				<MaterialRateSource className={styles.rateSource} rateSource={MaterialCostSource.JOB_MATERIAL} /> Overrides on individual material on job
			</div>
			<span className={styles.followingDayDisclaimer}>Any changes on rates are valid from the following day.</span>
		</div>
	);
};

export default React.memo(TableLegend);
